import { KeyValueModel } from "model/api";
import { EnumRetiradaStatus } from "model/enums";

export const RetiradaStatusMock: KeyValueModel[] = [
    new KeyValueModel(EnumRetiradaStatus.PENDENTE, "Pendente"),
    new KeyValueModel(EnumRetiradaStatus.CONCLUIDO, "Concluído"),
    new KeyValueModel(EnumRetiradaStatus.ERRO, "Erro"),
    new KeyValueModel(EnumRetiradaStatus.PROCESSANDO, "Processando"),
];